<i18n>
{
  "en":{
    "title": "TsumTsum hearts received/sent record",
    "recordIdNotFound": "Record ID not found, please check record folder ID.",
    "selectMonth": "Select Record Month",
    "overview": "Record Overview",
    "receiveHeartsReport": "Receive Hearts Report",
    "sendHeartsReport": "Send Hearts Report",
    "playGameReport": "Play Game Report",
    "days-hearts": "Hearts/Days",
    "days-hours-count": "Count (Hours/Days)",
    "days-games": "Games/Days",
    "download-excel": "Download Record",
    "no-record": "The records is on the way! Come back later to see the heart trading result",
    "timezone-info": "The record time is set to Coordinated Universal Time GMT +0:00",
    "now-time": "Time now:",
    "shareRecord": "Share Record",
    "shareRecordCopied": "Record link had been copied: ",
    "otherReport": "Other records",
    "buyBoxReport": "Boxes opened/Days",
    "upgradeReport": "TsumTsum upgraded/Days"
  },
  "zhHant":{
    "title": "TsumTsum 收心/送心紀錄",
    "recordIdNotFound": "Record ID 不存在, 請確認您的 folder ID 是否正確",
    "selectMonth": "選擇紀錄月份",
    "overview": "紀錄總覽",
    "receiveHeartsReport": "收心數總覽",
    "sendHeartsReport": "送心數總覽",
    "playGameReport": "玩遊戲次數總覽",
    "days-hearts": "愛心/日",
    "days-hours-count": "次數 (小時/日)",
    "days-games": "遊戲數/日",
    "download-excel": "下載紀錄",
    "no-record": "紀錄正在努力累積中呦！請稍後再試",
    "timezone-info": "紀錄時間為格林威治標準時間 GMT +0:00",
    "now-time": "現在是：",
    "shareRecord": "分享紀錄",
    "shareRecordCopied": "紀錄連結已複製：",
    "otherReport": "其他紀錄",
    "buyBoxReport": "開箱次數/日",
    "upgradeReport": "升級角色次數/日"
  },
  "ja":{
    "title": "ツムツム ハート送受信の記録",
    "recordIdNotFound": "記録IDが見つかりません。記録フォルダのIDをご確認ください。",
    "selectMonth": "表示する月を選択",
    "overview": "記録の概要",
    "receiveHeartsReport": "ハート受信数",
    "sendHeartsReport": "ハート送信数",
    "playGameReport": "ゲームのプレイ回数",
    "days-hearts": "ハート/日",
    "days-hours-count": "時間帯別の回数",
    "days-games": "プレイ回数/日",
    "download-excel": "記録をダウンロード",
    "no-record": "記録を集計中です。しばらくしてから再度お試しください。",
    "timezone-info": "記録の時刻は、日本時間ではなく協定世界時（UTC）で表示されます。日本時間から9時間を引いた時刻です。",
    "now-time": "UTCの現在時刻：",
    "shareRecord": "記録をシェア",
    "shareRecordCopied": "リンクをコピーしました：",
    "otherReport": "その他の記録",
    "buyBoxReport": "BOX開封数/日",
    "upgradeReport": "ツムレベル上限解放/日"
  },
  "ko":{
    "title": "디즈니 썸썸 하트 자동발송/받기 기록",
    "recordIdNotFound": "Record ID가 존재하지 않습니다, 당신의 folder ID가 올바른지 확인 바랍니다",
    "selectMonth": "기록 달을 선택하세요",
    "overview": "기록 개요",
    "receiveHeartsReport": "받은 하트 리포트",
    "sendHeartsReport": "발송 하트 리포트",
    "playGameReport": "플레이 횟수 리포트",
    "days-hearts": "하트/일",
    "days-hours-count": "횟수(시/일)",
    "days-games": "게임 횟수/일",
    "download-excel": "기록 다운로드",
    "no-record": "기록 준비 중입니다. 잠시 후 다시 확인해 주세요.",
    "timezone-info": "기록 시간은 그리니치 표준시 GMT+0:00입니다",
    "now-time": "지금은:",
    "shareRecord": "기록 공유",
    "shareRecordCopied": "기록 연결이 복사되었습니다:",
    "otherReport": "기타 기록",
    "buyBoxReport": "상자 오픈/일",
    "upgradeReport": "썸썸 레벨 잠금 해제 횟수/일"
  }
}
</i18n>

<template>
  <v-container fluid class="pa-0">
    <v-dialog v-model="shareRecordCopyDialog" max-width="400">
      <v-card>
        <v-card-text>{{ $t('shareRecordCopied') }} {{ recordURL }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="shareRecordCopyDialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card class="ma-2">
      <v-card-title class="title">
        {{ $t('title') }}
      </v-card-title>
      <v-card-text>
        <v-layout v-if="recordId === ''" row wrap>
          <v-flex xs1> </v-flex>
          <v-flex xs6 md6 lg4>
            {{ $t('recordIdNotFound') }}
          </v-flex>
        </v-layout>
        <v-select v-if="reportMonthSelectors.length != 0" :items="reportMonthSelectors" filled
          :label="$t('selectMonth')" v-model="selectedMonth" @change="onMonthSelected"></v-select>
      </v-card-text>
      <v-card-text v-if="record !== null" class="pt-0">
        <v-layout>
          <v-flex xs6>
            <v-btn color="primary" block @click="downloadExcel()">{{ $t('download-excel') }}</v-btn>
          </v-flex>
          <v-flex xs6>
            <v-btn color="success" block @click="shareRecord()">{{ $t('shareRecord') }}</v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-progress-linear :indeterminate="loading" v-if="loading" color="green" class="ma-0"
      height="3"></v-progress-linear>
    <v-layout v-if="failedToDownload" row wrap>
      <v-flex xs12 md12 lg12>
        <v-card>
          <v-card-title>
            {{ $t('no-record') }}
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-if="record !== null">
      <v-flex xs12>
        <v-card class="ma-2">
          <v-alert value="info" type="info" outline>
            <div>{{ $t('timezone-info') }}</div>
            <div>{{ $t('now-time') }} {{ nowUTCTimeString }}</div>
          </v-alert>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-if="record !== null" row wrap>
      <v-flex xs12 md12 lg12 class="ml-5 mr-5"> </v-flex>
      <v-flex xs12 md4 lg4>
        <v-card class="ma-2" v-if="showRecordId !== ''">
          <v-card-title class="title">
            {{ $t('overview') }}
          </v-card-title>
          <v-expansion-panel class="pl-2 pr-4" :expand="true" :value="expansion">
            <v-expansion-panel-content>
              <template v-slot:header>
                <div>{{ $t('receiveHeartsReport') }}</div>
              </template>
              <div class="pl-4">{{ $t('days-hearts') }}</div>
              <TsumLineChart :data="recordDetails[showRecordId].receiveDays" />
              <div class="pl-4">{{ $t('days-hours-count') }}</div>
              <TsumPlotXY :data="recordDetails[showRecordId].receiveHours" />
            </v-expansion-panel-content>
            <v-expansion-panel-content>
              <template v-slot:header>
                <div>{{ $t('sendHeartsReport') }}</div>
              </template>
              <TsumLineChart :data="recordDetails[showRecordId].sendDays" />
              <div class="pl-4">{{ $t('days-hours-count') }}</div>
              <TsumPlotXY :data="recordDetails[showRecordId].sendHours" />
            </v-expansion-panel-content>
            <v-expansion-panel-content>
              <template v-slot:header>
                <div>{{ $t('playGameReport') }}</div>
              </template>
              <div class="pl-4">{{ $t('days-games') }}</div>
              <TsumLineChart :data="recordDetails[showRecordId].playGameDays" />
              <div class="pl-4">{{ $t('days-hours-count') }}</div>
              <TsumPlotXY :data="recordDetails[showRecordId].playGameHours" />
            </v-expansion-panel-content>
            <v-expansion-panel-content>
              <template v-slot:header>
                <div>{{ $t('otherReport') }}</div>
              </template>
              <div class="pl-4">{{ $t('buyBoxReport') }}</div>
              <TsumLineChart :data="recordDetails[showRecordId].buyBoxDays" />
              <div class="pl-4">{{ $t('upgradeReport') }}</div>
              <TsumLineChart :data="recordDetails[showRecordId].unlockLevelDays" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card>
      </v-flex>
      <v-flex xs12 md8 lg8>
        <!-- <v-card class="ma-2" height="64">
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn-toggle v-model="showMode">
              <v-btn flat value="viewer">Viewer</v-btn>
              <v-btn flat value="settings">Settings</v-btn>
            </v-btn-toggle>
          </v-card-actions>
        </v-card> -->

        <!-- <TsumUserSetting
          :userImages="images"
          :value="settings"
          v-if="showMode == 'settings'"
          @update="settingsUpdate"
        /> -->
        <TsumUserList v-if="showMode == 'viewer' && showRecordId !== ''" :userImages="images"
          :record="recordDetails[showRecordId]" :settings="settings" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import JSZipUtils from 'jszip-utils';
import gzip from 'gzip-js';
import untar from 'js-untar';
import BitArray from 'bit-array';
import VueResource from 'vue-resource';
import Vue from 'vue';
import TsumUserList from '../components/tsum-record/TsumUserList.vue';
// import TsumUserSetting from "../components/tsum-record/TsumUserSetting.vue";
import TsumPlotXY from '../components/tsum-record/TsumPlotXY.vue';
import TsumLineChart from '../components/tsum-record/TsumLineChart.vue';
import localforage from 'localforage';
import firebase from 'firebase';
import { TsumRecordExcel } from '../plugins/tsumRecord';
import moment from 'moment';
require('firebase/functions');

Vue.use(VueResource);

export default {
  components: {
    TsumUserList,
    // TsumUserSetting,
    TsumPlotXY,
    TsumLineChart,
  },
  data() {
    return {
      shareRecordCopyDialog: false,
      recordURL: window.location.href,
      nowUTCTimeString: new Date().toUTCString(),
      selectedMonth: '',
      expansion: [true, true, true, true],
      licenseSelectors: [],
      reportMonthSelectors: [],
      recordId: '',
      showRecordId: '',
      showMode: 'viewer',
      loading: false,
      uploading: false,
      dashboardPanelState: [true, true, false, false],
      failedToDownload: false,

      files: null,
      images: null,
      record: null,
      recordDetails: null,
      sortedRecord: [],
      settings: {
        groups: {
          g01: { name: 'Group 1', members: {} },
          g02: { name: 'Group 2', members: {} },
          g03: { name: 'Group 3', members: {} },
          g04: { name: 'Group 4', members: {} },
          g05: { name: 'Group 5', members: {} },
          g06: { name: 'Group 6', members: {} },
        },
        alias: {}, // {[userId: string]: string}
      },
      settingsTimeoutId: 0,
    };
  },
  async mounted() {
    this.recordId = this.$route.params.recordId || '';
    this.$gtag.event('tsumRecordPage', 'enter', this.recordId, 1);
    await this.initData();
    if (this.reportMonthSelectors.length !== 0) {
      this.showRecordId = this.reportMonthSelectors[0].value;
      this.selectedMonth = this.reportMonthSelectors[0].value;
    }
    setInterval(() => {
      this.nowUTCTimeString = new Date().toUTCString();
    }, 1000);
  },
  computed: {},
  watch: {
    isLoadingLicenses: function () {
      if (this.licenseSelectors.length !== 0) {
        return;
      }
      for (const licenseId in this.licenses) {
        let recordPath = licenseId;
        const license = this.licenses[licenseId];
        if (license.taskConfig.recordFolderId != '') {
          recordPath = license.taskConfig.recordFolderId;
        }
        this.licenseSelectors.push({ text: licenseId, value: recordPath });
      }
    },
  },
  methods: {
    shareRecord() {
      this.shareRecordCopyDialog = true;
      this.$copyText(this.recordURL);
      this.$gtag.event('tsumRecordPage', 'share', this.recordId, 1);
    },
    downloadExcel() {
      const excel = new TsumRecordExcel(this.recordId, this.record, this.recordDetails, this.images);
      excel.makeExcel();
      this.$gtag.event('tsumRecordPage', 'excel', this.recordId, 1);
    },
    async getRecordDownloadURL() {
      const result = await firebase.functions().httpsCallable('XRobotmonGroup-xGetTsumRecordDownloadURL')({
        recordId: this.recordId,
      });
      return result.data;
    },
    async onLicenseSelected(v) {
      this.recordId = v;
      this.reportMonthSelectors.splice(0, this.reportMonthSelectors.length);
      await this.initData();
    },
    async onMonthSelected(v) {
      console.log(v);
      this.showRecordId = v;
    },
    async initData(forceUpdated = false) {
      this.loading = true;
      try {
        // const settings = await this.downloadSettings();
        // this.$set(this, "settings", settings);

        this.files = await this.downloadAndUnzip(forceUpdated);
        this.images = {};
        this.recordDetails = {};
        console.log(this.files);
        for (const file of this.files) {
          if (file.size === 0) {
            continue;
          }
          const basename = file.name.substr(28);
          if (basename === 'record.txt') {
            const txt = this.arrayBufferToString(file.buffer);
            this.record = JSON.parse(txt);
          } else if (basename.search('record') !== -1 && basename.search('.txt') !== -1) {
            if (basename.search('test') !== -1) {
              continue;
            }
            const recordId = basename.substr(7, basename.length - 4 - 7);
            const txt = this.arrayBufferToString(file.buffer);
            const data = JSON.parse(txt);
            const tmp = {};
            for (const userId in data.receiveDetail) {
              tmp[userId] = new BitArray(768, data.receiveDetail[userId]);
            }
            data.receiveDetail = tmp;
            this.reportMonthSelectors.push({
              text: `${data.year}-${data.month + 1}`,
              value: data.recordId,
            });
            this.reportMonthSelectors.sort((a, b) => {
              return moment(b.text).unix() - moment(a.text).unix();
            });
            this.recordDetails[recordId] = data;
          } else {
            let id = '';
            let key = '';
            if (basename.search('_big') !== -1) {
              id = basename.substr(0, 15) + '.png';
              key = 'big';
            } else if (basename.search('f_icon') !== -1) {
              id = basename.substr(7, 15) + '.png';
              key = 'icon';
            } else if (basename.search('f_name') !== -1) {
              id = basename.substr(7, 15) + '.png';
              key = 'name';
            }
            if (this.images[id] === undefined) {
              this.images[id] = { big: null, icon: null, name: null };
            }
            // this.images[id][key] = file.buffer;
            this.images[id][key] = window.URL.createObjectURL(new Blob([file.buffer]));
            this.images[id][key + 'buffer'] = file.buffer;
          }
        }
      } catch (e) {
        console.log(e);
        this.failedToDownload = true;
      }
      console.log('record', this.record);
      console.log('recorddetail', this.recordDetails);
      console.log('images', this.images);
      this.loading = false;
    },
    arrayBufferToString(buffer) {
      let str = '';
      const bytes = new Uint8Array(buffer);
      const len = bytes.byteLength;
      for (let i = 0; i < len; i++) {
        str += String.fromCharCode(bytes[i]);
      }
      return str;
    },
    changeDate(year, month) {
      this.showYear = year;
      this.showMonth = month;
      this.showRecordId = `${year}_${month}`;
    },
    async settingsUpdate() {
      this.uploading = true;
      if (this.settingsTimeoutId !== 0) {
        clearTimeout(this.settingsTimeoutId);
      }
      this.settingsTimeoutId = setTimeout(async () => {
        this.settingsTimeoutId = 0;
        await this.uploadSettings();
        this.uploading = false;
      }, 3 * 1000);
    },
    async downloadAndUnzip(forceUpdate = false) {
      const url = await this.getRecordDownloadURL();
      console.log('this', this.recordId);
      let lastDownlaodTime = await localforage.getItem(`lastDownloadTime_${this.recordId}`);
      let base64string = await localforage.getItem(this.recordId);
      if (
        forceUpdate ||
        base64string === null ||
        lastDownlaodTime === null ||
        Date.now() - lastDownlaodTime > 3600 * 1000
      ) {
        const gz = await new Promise(function (resolve, reject) {
          JSZipUtils.getBinaryContent(url, function (err, data) {
            if (err) {
              reject(err);
            } else {
              resolve(data);
            }
          });
        });
        base64string = this.arrayBufferToBase64(gz);
        console.log('downloaded', base64string.length);
        this.$gtag.event('tsumRecordPage', 'downloaded', this.recordId, 1);

        await localforage.setItem(`lastDownloadTime_${this.recordId}`, Date.now());
        await localforage.setItem(this.recordId, base64string);
      } else {
        this.$gtag.event('tsumRecordPage', 'cached', this.recordId, 1);

        console.log(
          'load from cache size',
          base64string.length,
          'next update',
          new Date(lastDownlaodTime + 3600 * 1000)
        );
      }
      const arrayBuffer = this.base64ToArrayBuffer(base64string);
      const out = gzip.unzip(new Uint8Array(arrayBuffer));
      return await new Promise(function (resolve, reject) {
        untar(new Uint8Array(out).buffer).then(
          function (extractedFiles) {
            resolve(extractedFiles);
          },
          function (err) {
            reject(err);
          },
          function () { }
        );
      });
    },
    async downloadSettings() {
      const settingURL = `https://storage.googleapis.com/xr-tsum-record/v3-${this.recordId
        }/settings.txt?avoidCache=${Date.now()}`;
      try {
        const resp = await this.$http.get(settingURL);
        return resp.body;
      } catch (e) {
        console.log(e);
        alert(`Can not get settings, maybe no record`);
      }
    },
    async uploadSettings() {
      const settingURL = `https://storage.googleapis.com/xr-tsum-record/v3-${this.recordId}/settings.txt`;
      try {
        await this.$http.put(settingURL, JSON.stringify(this.settings));
        return true;
      } catch (e) {
        console.log(e);
        alert(`Can not save settings, please try again`);
      }
      return false;
    },
    arrayBufferToBase64(buffer) {
      let binary = '';
      const bytes = new Uint8Array(buffer);
      const len = bytes.byteLength;
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    },
    base64ToArrayBuffer(base64) {
      const binary_string = window.atob(base64);
      const len = binary_string.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }
      return bytes.buffer;
    },
  },
};
</script>

<style></style>
